import { LogOut, ShieldAlert } from "lucide-react";
import { useImpersonation } from "@/hooks/useImpersonation";

/**
 * Barra fija superior, siempre visible mientras el superadmin está
 * "Accediendo como" un cliente. Se monta en el layout autenticado
 * (`Layout.tsx`), por encima de la Navbar (que se desplaza hacia abajo
 * cuando este banner está activo — ver `Navbar.tsx`/`Sidebar.tsx`).
 */
export default function ImpersonationBanner() {
  const { isImpersonating, targetLabel, stop, isStopping } =
    useImpersonation();

  if (!isImpersonating) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[70] h-[calc(40px+var(--safe-top))] pt-[var(--safe-top)] bg-amber-500 text-white flex items-center justify-center gap-2 px-3 text-xs sm:text-sm font-medium shadow-md">
      <ShieldAlert className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="truncate">
        Estás viendo como{" "}
        <strong className="font-bold">{targetLabel || "otro usuario"}</strong>
      </span>
      <button
        onClick={stop}
        disabled={isStopping}
        className="ml-2 inline-flex items-center gap-1 rounded-md bg-white/20 hover:bg-white/30 px-2.5 py-1 font-semibold shrink-0 disabled:opacity-60 disabled:cursor-not-allowed"
      >
        <LogOut className="h-3.5 w-3.5" aria-hidden="true" />
        {isStopping ? "Saliendo..." : "Salir"}
      </button>
    </div>
  );
}
